import request from "../assets/script/request";


/**
 * 获取企业信息列表
 */
export const queryCompanyList = (query) => {
  return request({
    url: "/common/company/queryCompanyList",
    method: "POST",
    data: query
  })
}

/**
 * 获取企业详情
 */
export const queryCompanyById = (query) => {
  return request({
    url: "/common/company/queryCompanyById",
    method: "POST",
    data: query
  })
}

/**
 * 获取企业详情中的化学品列表
 */
export const queryCmpChmBaseList = (query) => {
  return request({
    url: "/common/chemical/queryCmpChmBaseList",
    method: "POST",
    data: query
  })
}

/**
 * 获取企业详情中的化学品详情
 */
export const queryCmpChmDetailById = (query) => {
  return request({
    url: "/common/chemical/queryCmpChmDetailById",
    method: "POST",
    data: query
  })
}

/**
 * 获取登记中心的化学品
 */
export const queryChemicalList = (query) => {
  return request({
    url: "/common/chemical/queryChemicalList",
    method: "POST",
    data: query
  })
}

/**
 * 获取登记中心的化学品详情
 */
export const queryChemicalById = (query) => {
  return request({
    url: "/common/chemical/queryChemicalById",
    method: "POST",
    data: query
  })
}

/**
 * 获取行政区划
 */
export const queryAreaList = (query) => {
  return request({
    url: "/common/cmn/queryAreaList",
    method: "POST",
    data: query
  })
}

/**
 * 获取登实训基地列表
 */
export const queryTrainInfoList = (query) => {
  return request({
    url: "/common/train/queryTrainInfoList",
    method: "POST",
    data: query
  })
}

/**
 * 获取登记系统中实训基地列表
 */
export const parkTranBaseInfoList = (query) => {
  return request({
    url: "/common/train/parkTranBaseInfoList",
    method: "POST",
    data: query
  })
}

/**
 * 获取登记系统中实训基地详情
 */
export const queryTranBaseInfo = (query) => {
  return request({
    url: "/common/train/queryTranBaseInfo",
    method: "POST",
    data: query
  })
}

/**
 * 获取字典
 */
export function queryEnterpriseType(query) {
  return request({
    url: "/common/cmn/selectEnterpriseType/" + query,
    method: "GET"
  })
}

/**
 * 获取一企一品一码查询
 */
export const querySomeChemicals = (query) => {
  return request({
    url: "/common/chemical/querySomeChemicals",
    method: "POST",
    data: query
  })
}

/**
 * 知识园地类查询
 */
export const queryContentList = (query) => {
  return request({
    url: "/common/content/queryContentList",
    method: "POST",
    data: query
  })
}

/**
 * 知识园地类详情
 */
export const queryContentById = (query) => {
  return request({
    url: "/common/content/queryContentById",
    method: "POST",
    data: query
  })
}

/**
 * 首页统计
 */
export const queryHomeStatistics = (query) => {
  return request({
    url: "/common/cmn/queryHomeStatistics",
    method: "POST",
    data: query
  })
}

/**
 * 保存留言
 */
export const saveInteract = (query) => {
  return request({
    url: "/common/interact/saveInteract",
    method: "POST",
    data: query
  })
}

/**
 * 查询留言列表
 */
export const queryInteractList = (query) => {
  return request({
    url: "/common/interact/queryInteractList",
    method: "POST",
    data: query
  })
}

/**
 * 获取友情链接的列表
 */
export const queryUrlList = (query) => {
  return request({
    url: "/common/url/queryUrlList",
    method: "POST",
    data: query
  })
}

/**
 * 化学品目录列表
 */
export const queryChemDirectoryList = (query) => {
  return request({
    url: "/common/chemical/queryChemDirectoryList",
    method: "POST",
    data: query
  })
}

/**
 * 化学品目录列表
 */
export const getDanChemInfoListNew = (query) => {
  return request({
    url: "/common/chemical/getDanChemInfoListNew",
    method: "POST",
    data: query
  })
}

/**
 * 获取图片验证码
 */
export const pictureCaptcha = () => {
  return request({
    url: "/common/interact/pictureCaptcha",
    method: "POST",
  })
}

/**
 * 获取手机验证码
 */
export const sendMessage = (query) => {
  return request({
    url: "/common/interact/sendMessage",
    method: "POST",
    data: query
  })
}
